import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-681b9128"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "include-cell" }
const _hoisted_2 = { class: "button-footer" }

import { computed, PropType } from "vue";
import DxButton from "devextreme-vue/button";
import GridBase from "@/components/ui/grid/grid-base.vue";
import { DxColumn } from "devextreme-vue/data-grid";
import SwitchToggle from "@/components/ui/toggles/switch-toggle.vue";
import { useScreenHelper } from "@/utils/system/ScreenHelper";
import { SummaryStatementItem } from "@/types/financials/SummaryStatement";


export default /*#__PURE__*/_defineComponent({
  __name: 'summary-statement-grid',
  props: {
  /**
   * Array of SummaryStatementItem objects to be displayed in the grid.
   * @type {SummaryStatementItem[]}
   * @required true
   */
  summaryStatementsList: {
    type: Array as PropType<SummaryStatementItem[]>,
    required: true,
  },
  /**
   * Indicates whether data is being loaded and the grid should show a loading state.
   * @type {Boolean}
   * @required true
   */
  loading: {
    type: Boolean,
    required: true,
  },
  /**
   * Determines whether the control is read only.
   * @type {boolean}
   * @default true
   */
  readOnly: {
    type: Boolean,
    default: true,
  },
},
  emits: [
  /**
   * Emits the updated summary statements list to the parent component
   * when the include status of any item changes via toggle, select all, or clear actions.
   * @event update:summaryStatementsList
   */
  "update:summaryStatementsList",
],
  setup(__props, { emit }) {

const props = __props;





const { isMobile } = useScreenHelper();

const localList = computed({
  get: () => props.summaryStatementsList.map((item) => ({ ...item })),
  set: (value) => {
    emit("update:summaryStatementsList", value);
  },
});

const setAllIncludeStatus = (status: boolean) => {
  const updatedList = localList.value.map((item) => ({
    ...item,
    include: status,
  }));
  localList.value = updatedList;
};

const handleSingleChange = (rowData: SummaryStatementItem) => {
  const updatedList = localList.value.map((item) => {
    if (item.id === rowData.id) {
      return { ...item, include: !item.include };
    }
    return item;
  });

  localList.value = updatedList;
};

const contactFieldWidth = computed(() => (isMobile.value ? "180" : undefined));

const onSelectAllClick = () => {
  setAllIncludeStatus(true);
};

const onClearClick = () => {
  setAllIncludeStatus(false);
};

const gridHeight = computed(() => {
  return isMobile.value ? "" : `height: 220px;`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      style: _normalizeStyle(gridHeight.value)
    }, [
      (_openBlock(), _createBlock(GridBase, {
        "data-source": localList.value,
        "id-column-name": "id",
        "column-auto-width": true,
        loading: __props.loading,
        wordWrapEnabled: true,
        showSearchPanel: false,
        "custom-column-slots": ['includeCell'],
        key: localList.value.length
      }, {
        columns: _withCtx(() => [
          _createVNode(_unref(DxColumn), {
            "data-field": "contact",
            caption: "Contact",
            width: contactFieldWidth.value,
            "hiding-priority": 5
          }, null, 8, ["width"]),
          _createVNode(_unref(DxColumn), {
            "data-field": "property",
            caption: "Property",
            width: 435,
            "hiding-priority": 3
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "include",
            caption: "Include",
            width: 68,
            "hiding-priority": 4,
            "cell-template": "includeCell"
          })
        ]),
        includeCellData: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(SwitchToggle, {
              "model-value": data.include,
              "read-only": __props.readOnly,
              "onUpdate:modelValue": () => handleSingleChange(data)
            }, null, 8, ["model-value", "read-only", "onUpdate:modelValue"])
          ])
        ]),
        _: 1
      }, 8, ["data-source", "loading"]))
    ], 4),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(DxButton), {
        text: 'Clear',
        type: __props.readOnly ? 'normal' : 'default',
        "styling-mode": "contained",
        disabled: __props.readOnly,
        onClick: onClearClick
      }, null, 8, ["type", "disabled"]),
      _createVNode(_unref(DxButton), {
        text: 'Select All',
        type: __props.readOnly ? 'normal' : 'default',
        "styling-mode": "contained",
        disabled: __props.readOnly,
        onClick: onSelectAllClick
      }, null, 8, ["type", "disabled"])
    ])
  ], 64))
}
}

})